/*
 * This needs to be called from login.coinbase.com or any other
 * entry point from the mobile app. Any repository mounting
 * the CookieBanner will also inherit this behavior.
 *
 * The purpose here is to allow the iOS app to send a is_mobile_app=true
 * parameter that should indicate to the web surfaces not to show the
 * cookie banner (#inci-11-27-17104-ios-1146-rejection).
 *
 * This solution allows for that parameter to persist across all
 * coinbase.com domains and sub-domains.
 */

function persistMobileAppPreferences() {
  try {
    const isMobileApp = getAppTrackingTransparencyFromQueryParams() || window.isWebView;
    /*
     * Previously a check against the `is_mobile_app` URL parameter was done when a WebView was opened,
     * but we are checking the iOS App Tracking Transparency (ATT) and setting the configuration as a URL
     * parameter `app_tracking_transparency_enabled` to determine if tracking should be allowed downstream.
     *
     * The `is_mobile_app` cookie will not be changed because there are references to this
     * value downstream, a number  which means if we changed the name of this cookie there would be
     * unintended behavior. As an example, refer to the `useSavedTrackingPreferenceFromMobileApp` hook where the
     * `advertising_sharing_allowed` cookie is set based on the value of `is_mobile_app`.
     */

    if (isMobileApp) {
      // Tracking is disabled if `is_mobile_app` is set.
      document.cookie = 'is_mobile_app=true; domain=.coinbase.com';
    }
  } catch (e) {
    // Ignore, we are not in a browser.
  }
}
function getAppTrackingTransparencyFromQueryParams() {
  try {
    const params = new URLSearchParams(window.location.search);
    const appTrackingTransparency = params.get('app_tracking_transparency_enabled') === 'true';
    return Boolean(appTrackingTransparency);
  } catch (e) {
    // Ignore, we are not in a browser.
  }
  return false;
}
export { getAppTrackingTransparencyFromQueryParams, persistMobileAppPreferences };
//# sourceMappingURL=persistMobileAppPreferences.js.map
